import { render, staticRenderFns } from "./app-secure-menu.vue?vue&type=template&id=643e89e8&scoped=true&"
import script from "./js/app-secure-menu.js?vue&type=script&lang=js&"
export * from "./js/app-secure-menu.js?vue&type=script&lang=js&"
import style0 from "./app-secure-menu.vue?vue&type=style&index=0&id=643e89e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643e89e8",
  null
  
)

export default component.exports